import { useTheme } from 'styled-components';
import { TestItemSummary } from '../../../2_domain/test/test';
import { toIDPrice } from '../../../lib/util/numberFormatter';
import Row from '../../core/components/box/row';
import SizedBox from '../../core/components/box/sizedBox';
import { LXbody, LXbodyLong } from '../../core/texts/lxText';

interface TestItemViewProps {
  testItem: TestItemSummary;
  propWidth: string;
}

const TestItemView = ({ testItem, propWidth }: TestItemViewProps) => {
  const theme = useTheme();

  const propertyMap = new Map<string, string>();

  propertyMap.set(theme.test.testCode, testItem.serial);
  propertyMap.set(theme.test.category, testItem.testCategory.label);
  propertyMap.set('Specimen', testItem.specimen?.toString());
  propertyMap.set(theme.test.price, toIDPrice(testItem.amount, true));
  propertyMap.set(
    theme.test.reported,
    `${testItem.requiredDays?.toString()} Days`
  );
  propertyMap.set('Information', testItem.longInformation?.toString());
  propertyMap.set('Reference Range', testItem.longReferenceRange?.toString());
  propertyMap.set('Volume', testItem.sampleCollectingFigure?.toString());
  // propertyMap.set('shortInformation', testItem.shortInformation?.toString());
  // propertyMap.set(
  //   'sampleCollectingFigure',
  //   testItem.sampleCollectingFigure?.toString()
  // );
  // propertyMap.set(
  //   'shortReferenceRange',
  //   testItem.shortReferenceRange?.toString()
  // );

  const TestItemProperty = ({
    propWidth,
    name,
    description,
  }: {
    propWidth: string;
    name: string;
    description: string;
  }) => {
    const theme = useTheme();
    return (
      <Row padding="0 0 16px" width="100%" alignItems="flex-start">
        <LXbody flexShrink={0} color={theme.colors.caption} width={propWidth}>
          {name}
        </LXbody>
        <SizedBox width={30} />
        <LXbodyLong>{description}</LXbodyLong>
      </Row>
    );
  };

  return (
    <>
      {Array.from(propertyMap.entries()).map(([key, value]) => {
        return (
          <TestItemProperty
            key={key}
            propWidth={propWidth}
            name={key}
            description={value}
          />
        );
      })}
    </>
  );
};

export default TestItemView;
